import axios from 'axios';
import ApiUrl from './config';

// Подтверждение почты при регистрации (эндпоинтов ещё нет в сгенерированном apiClient).

export const REGISTRATION_CODE_LENGTH = 6;
/** Через сколько секунд после отправки можно запросить код повторно (должно совпадать с сервером). */
export const REGISTRATION_RESEND_SECONDS = 30;

export async function confirmRegistration(email: string, code: string): Promise<void> {
  await axios.post(`${ApiUrl}/api/Auth/register/confirm`, { email, code });
}

export async function resendRegistrationCode(email: string): Promise<void> {
  await axios.post(`${ApiUrl}/api/Auth/register/resend-code`, { email });
}
